export default {
    messages_chat: [],
    opened_transcription: [],
    loader: false,
};